import { windowFactory } from './window.factory';

let configOverrides: Partial<AppConfig> = {};

export function appConfigFactory(): AppConfig {
  return {
    ...windowFactory().ghsConfiguration,
    ...configOverrides,
  };
}

export function mergeConfigOverrides(
  configurationOverrides: Partial<AppConfig>,
): void {
  configOverrides = configurationOverrides ?? {};
}
